import { useEffect,useState } from 'react'
import { useNavigate,useParams } from 'react-router-dom'
import { Alert, Box, Button, Card, CardContent, Grid, IconButton, Menu, MenuItem } from '@mui/material'
import { post } from '../../../utils/axios'
import { toast } from 'react-toastify'
import MoreVertIcon from '@mui/icons-material/MoreVert'

const ChildrenTransactions = () => {

    const navigate = useNavigate()
    const {childId} = useParams()

    const [isLoading,setIsLoading] = useState(true)
    const [optionsMenu,setOptionsMenu] = useState(false)
    const [name,setName] = useState('شریک')
    const [userSegments,setUserSegments] = useState([])
    const [currentSegment,setCurrentSegment] = useState({})
    const open = Boolean(optionsMenu)
    
    const getData = () => {
        const postedData = {
            childId
        }
        post('ChildUser/GetTrasactionInfoChildUser',postedData).then(({data}) => {
            if(data.isSuccess)
                setUserSegments(data.data)
            else
                setUserSegments([])
        }).finally(() => {
            setIsLoading(false)
        })
    }

    useEffect(() => {
        post('ChildUser/GetChildUserByParentId').then(({data}) => {
            if(data.isSuccess){
                const child = data.data.find(ch => ch.id == childId)
                if(child)
                    setName(`${child.firstName} ${child.lastName}`)
            }
        }).finally(() => {
            setIsLoading(false)
        })
        getData()
    },[])
    const openOptions = (e,segment) => {
        setOptionsMenu(e)
        setCurrentSegment(segment)
    }

    const changeStatus = (e) => {
        const postedData = {
            id: currentSegment.id
        }
        const segment = userSegments.find(segment => segment.id == currentSegment.id)
        if(!segment)
            return toast.error('منابع مالی مورد نظر یافت نشد')
        post('ChildUser/DeActiveTrasactionChildUserById',postedData).then(({data}) => {
            if(data.isSuccess){
                getData()
                toast.success('منابع مالی مورد نظر با موفقیت غیرفعال شد')
            }else
                toast.error('عملیات مورد نظر ناموفق بود')
        }).finally(() => setOptionsMenu(null))
    }

    return (
        <Grid item px={0.3} sx={{position: 'relative'}}>
            <h3 className="others-page-title">لیست منابع مالی تخصیص یافته به {name}</h3>
            <Button className="btn-plus-item" variant="contained" onClick={() => navigate(`/app/children/${childId}/segments/add`)}><i className="fal fa-plus"></i></Button>
            <div className="safe-area">
                {isLoading ? [...Array(4)].map((item,index) => <Card sx={{width: '100%',mb: 2}} key={index}>
                    <CardContent sx={{py: 3,pb: 4}}>
                        <div className="child-row-placeholder">
                            <h4 className="segment-placeholder animate"></h4>
                            <p className="limited-usage-placeholder animate"></p>
                            <p className="limited-usage-placeholder animate"></p>
                        </div>
                    </CardContent>
                </Card>) : (userSegments.length ? <>
                    <Alert severity="info" sx={{mb: 2}}>با استفاده از دکمه + پایین صفحه می توانید منابع مالی جدیدی را تخصیص دهید</Alert>
                    <Alert severity="warning" sx={{ mb: 2 }}>جهت به روزرسانی هر کدام از منابع مالی، با استفاده از دکمه + پایین صفحه می توانید منبع مالی با شرایط جدید جهت تخصیص در سیستم اضافه کنید</Alert>
                    <Box sx={{mb: 15}}>
                        {userSegments.map(segment => <Card sx={{ width: '100%',mb: 2 }} key={segment.id}>
                            <CardContent sx={{ py: 3,pb: 4 }} className="segment-box">
                                <h4>{segment.segment}</h4>
                                <p className="limited-usage">سقف میزان قابل استفاده : <span>{segment.limitPercent ? `${segment.limitPercent} درصد و ` : ''}مبلغ {new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(segment.limit)}</span> ریال</p>
                                <p className="limited-usage">میزان استفاده شده : <span>مبلغ {new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(segment.purchaseAmount)}</span> ریال</p>
                                <p className="limited-usage">میزان قابل استفاده فعلی : <span>مبلغ {new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(segment.reminder)}</span> ریال</p>
                                <p className="time-usage">از تاریخ <span>{segment.fromDate}</span> الی <span>{segment.toDate}</span></p>
                                <div className="segment-row-btn-parent">
                                    <IconButton onClick={e => openOptions(e.currentTarget,segment)}><MoreVertIcon /></IconButton>
                                </div>
                            </CardContent>
                        </Card>)}
                        <Menu anchorEl={optionsMenu} open={open} onClose={() => setOptionsMenu(null)}>
                            <MenuItem onClick={e => changeStatus(e)}>غیرفعال سازی</MenuItem>
                        </Menu>
                    </Box>
                </> : <Alert severity="info" sx={{mb: 2}}>با استفاده از دکمه + پایین صفحه می توانید منابع مالی جدیدی را تخصیص دهید</Alert>)}
            </div>
        </Grid>
    )
}

export default ChildrenTransactions